var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C13.1946 17 17 13.1946 17 8.5C17 3.80544 13.1946 0 8.5 0C3.80544 0 0 3.80544 0 8.5C0 13.1946 3.80544 17 8.5 17ZM15.5732 8.5C15.5732 12.4059 12.4059 15.5732 8.5 15.5732C4.59414 15.5732 1.42678 12.4059 1.42678 8.5C1.42678 4.59414 4.59414 1.42469 8.5 1.42469C12.4079 1.42678 15.5732 4.59414 15.5732 8.5Z",
    fill: "#282828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2552 6.80973C12.2552 4.6319 10.5732 2.86621 8.49998 2.86621C6.42676 2.86621 4.74475 4.6319 4.74475 6.80973C4.74475 7.59006 4.96442 8.31809 5.3368 8.93106H5.33262C6.59831 11.0127 8.49998 14.134 8.49998 14.134L11.6673 8.93106H11.6632C12.0355 8.31809 12.2552 7.59215 12.2552 6.80973ZM8.49998 8.5001C7.61086 8.5001 6.89119 7.74278 6.89119 6.80973C6.89119 5.87667 7.61086 5.11935 8.49998 5.11935C9.3891 5.11935 10.1088 5.87667 10.1088 6.80973C10.1088 7.74278 9.3891 8.5001 8.49998 8.5001Z",
    fill: "#282828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.391ddb47815a8fcb80443e64503481ae.svg";
export { ForwardRef as ReactComponent };